import axios from '@/jslib/axios'

export const getFlightDelayList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/flight/delay/list',
    params,
    ...other
  })
}
export const getFlightDelayDetail= params => {
  return axios({
    method: 'get',
    url: '/admin/flight/delay/detail',
    params
  })
}
export const addFlightDelayRemark= data => {
  return axios({
    method: 'post',
    url: '/admin/flight/delay/add/remark',
    data
  })
}
export const claimSettleFlightDelay= data => {
  return axios({
    method: 'post',
    url: '/admin/flight/delay/claim/settle',
    data
  })
}
export const editFlightDelay= data => {
  return axios({
    method: 'post',
    url: '/admin/flight/delay/data/edit',
    data
  })
}
